import React from 'react';
import {
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { formatTooltipMoney } from '../helpers';

interface RevParTrendPoint {
  label: string;
  revpar: number;
}

interface Props {
  title: string;
  data: RevParTrendPoint[];
  isLoading: boolean;
  emptyMessage?: string;
  height?: number;
}

export const RevParTrendChart: React.FC<Props> = ({
  title,
  data,
  isLoading,
  emptyMessage = 'No RevPAR data for this period',
  height = 240,
}) => (
  <div className="rounded-2xl border border-gray-200 bg-white p-5">
    <div className="mb-4">
      <h4 className="text-sm font-semibold text-gray-900">{title}</h4>
      <p className="text-xs text-gray-400">Revenue per available room by day</p>
    </div>

    {data.length === 0 ? (
      <div
        className="flex items-center justify-center text-xs text-gray-400"
        style={{ height }}
      >
        {isLoading ? 'Loading…' : emptyMessage}
      </div>
    ) : (
      <ResponsiveContainer width="100%" height={height}>
        <LineChart
          data={data}
          margin={{ top: 8, right: 8, left: -20, bottom: 0 }}
        >
          <CartesianGrid
            strokeDasharray="3 3"
            vertical={false}
            stroke="#f0f0f0"
          />
          <XAxis
            dataKey="label"
            tick={{ fontSize: 10, fill: '#9ca3af' }}
            tickLine={false}
            axisLine={false}
            interval={data.length > 14 ? 2 : 0}
          />
          <YAxis
            tick={{ fontSize: 10, fill: '#9ca3af' }}
            tickLine={false}
            axisLine={false}
          />
          <Tooltip formatter={(value) => formatTooltipMoney(value)} />
          <Line
            type="monotone"
            dataKey="revpar"
            stroke="#15803d"
            strokeWidth={3}
            dot={{ r: 2 }}
            activeDot={{ r: 4 }}
          />
        </LineChart>
      </ResponsiveContainer>
    )}
  </div>
);
